import { render, staticRenderFns } from "./IncidentView.vue?vue&type=template&id=4959a798&scoped=true"
import script from "./IncidentView.vue?vue&type=script&lang=js"
export * from "./IncidentView.vue?vue&type=script&lang=js"
import style0 from "./IncidentView.vue?vue&type=style&index=0&id=4959a798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4959a798",
  null
  
)

export default component.exports